import React from 'react';
import { Trans } from '@lingui/react';
import styled from 'styled-components';
import { fromUnixTime, format } from 'date-fns';
import Icon from '@components/Icon';
import { Box, Flex } from '@components/layout/Grid';
import { ProgramCardDuration } from '@components/texts';
import MenuItemShareModal from '@ecosystems/MenuItemShareModal';
import Card from '@organisms/cards/Card';
import { State as Type } from './NewCourseCard';
import { ProgramCategory } from '@gql/generated';

const RightSectionThumbnailWrapper = styled.div<{ type?: string }>`
  position: absolute;
  width: 100px;
  height: 100%;
  top: 0;
  right: 0;
  background-color: ${props =>
    props.type === ProgramCategory['Courses']
      ? 'rgb(136,191,189, 0.9)'
      : 'rgba(86, 185, 229, 0.9)'};
  border-radius: 0 3px 0 0;
`;

const ProgramCard = props => {
  return (
    <Card
      className={props.className}
      href={props.program.path}
      thumbnailUrl={props.program.thumbnailUrl}
      thumbnailContent={
        <React.Fragment>
          {props.type && (
            <Type type={props.type}>
              {props.type === ProgramCategory['Courses'] ? (
                <Trans id="metadata.programLabel" message={'Program'} />
              ) : null}

              {props.type === ProgramCategory['Courses'] ? (
                <Trans id="metadata.courseLabel" message={'Course'} />
              ) : null}
            </Type>
          )}
          {props.tags ? (
            <Flex mt="5px" ml="4px">
              {props?.tags}
            </Flex>
          ) : null}
          {props.program.accessUntil ? (
            <RightSectionThumbnailWrapper type={props.type}>
              <Flex
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                p="15px"
                style={{ height: '100%' }}
              >
                <Box mb="10px" style={{ textAlign: 'center' }}>
                  <Icon
                    name="ygb-icon-program-ic"
                    fontSize="32px"
                    color="white"
                  />
                </Box>
                <Flex flexDirection="column">
                  <ProgramCardDuration>
                    <Trans id="metadata.accessUntil" message="Access Until" />
                  </ProgramCardDuration>
                  <ProgramCardDuration>
                    {format(
                      fromUnixTime(props.program.accessUntil),
                      'dd/MM/yyyy'
                    )}
                  </ProgramCardDuration>
                </Flex>
              </Flex>
            </RightSectionThumbnailWrapper>
          ) : null}
          {props.customRightSection ? props.customRightSection : null}
        </React.Fragment>
      }
      contentTitle={props.program.title}
      isContentDescriptionHTML
      contentDescription={props.program.description}
      contentCardLeftSection={
        props.favoritable ? <div>Favorite a program</div> : null
      }
      contentCardRightSection={
        <MenuItemShareModal
          resourceIdentifier={props.program.path}
          resource="program"
        />
      }
    />
  );
};
export default ProgramCard;
